// Before build, d4bbc3b6fa23e312bd989f25a1360c67 value will be changed by a proper hash
// which will be changed into angular.json file too
// and when build, all CSS files will have this hash in their name.
export const HASH: string = "d4bbc3b6fa23e312bd989f25a1360c67";
